import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavItem } from './navbar/nav-item';
import { NavList } from './navbar/nav-list';
import { ObjectObservable } from "../shared/base/object-observable";
import { User } from "../users/shared/user";

@Injectable()
export class NavService {
  private _title: string | NavItem;
  private _lectureTitle: string;
  private _slackUrl: string;
  private _public: boolean;
  private _navActivated: any[];
  private _subActivated: any[];
  private _navList: NavList;
  private _subList: NavList;
  private _userDetail: boolean;
  private _userObservable: ObjectObservable<User>;

  subOnly: boolean;
  navActions: NavItem[];
  actions: NavItem[];
  articleActions: NavItem[];
  lectureAction: NavItem;

  constructor(
    private titleService: Title) { }

  get userObservable(){
    return this._userObservable;
  }

  set userObservable(user: ObjectObservable<User>){
    this._userObservable = user;
  }

  set userDetail(userDetail: boolean) {
    this._userDetail = userDetail;
  }

  get userDetail() {
    return this._userDetail
  }

  get title() {
    return this._title;
  }

  set title(newTitle: string | NavItem) {
    this._title = newTitle;
    const titleText = newTitle ? (typeof newTitle === 'string' ? newTitle : newTitle.text) : null;
    this.titleService.setTitle(titleText);
  }

  get lectureTitle() {
    return this._lectureTitle;
  }

  set lectureTitle(newTitle: string) {
    this._lectureTitle = newTitle;
  }

  get slackUrl() {
    return this._slackUrl;
  }

  set slackUrl(slackUrl: string) {
    this._slackUrl = slackUrl;
  }

  get lecturePublic() {
    return this._public;
  }

  set lecturePublic(lcturePublic: boolean) {
    this._public = lcturePublic;
  }

  set navTitle(value: string) {
    if (this.navList) {
      this.navList.title = value;
    }
  }

  set subTitle(value: string) {
    if (this.subList) {
      this.subList.title = value;
    }
  }

  get navList(): NavList {
    return this._navList;
  }

  set navList(value: NavList) {
    this._navList = value;
    if (this.navList) {
      this.navList.activated = this._navActivated;
    }
  }

  get subList(): NavList {
    return this._subList;
  }

  set subList(value: NavList) {
    this._subList = value;
    if (this.subList) {
      this.subList.activated = this._subActivated;
    }
  }

  set navActivated(value: any[]) {
    this._navActivated = value;
    if (this.navList) {
      this.navList.activated = value;
    }
  }

  set subActivated(value: any[]) {
    this._subActivated = value;
    if (this.subList) {
      this.subList.activated = value;
    }
  }

  get activatedIdx(): number {
    const list = this.subList;
    return list ? list.items.findIndex(item => this.isActivated(list, item)) : -1;
  }

  isActivated(list: NavList, item: NavItem) {
    if (list.activated == null || item.commands == null) {
      return false;
    }
    return list.activated.toString() === item.commands.toString();
  }

  updateNavActions() {
    if (this.activatedIdx !== -1) {
      this.navActions = this.getNavActions(this.activatedIdx, this.subList.items);
    }
  }

  private getNavActions(activatedIdx: number, items: NavItem[]) {
    return [
      activatedIdx !== 0 ? items[activatedIdx - 1] : null,
      activatedIdx < items.length - 1 ? items[activatedIdx + 1] : null
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/nav.service.ts